<template>
    <Card>
        <FetchTable
            :url="`/projects/${$route.params.projectUuid}/pim/integrations/${integration.uuid}/ai-processes`"
            :handle="tableHandle"
            :columns="columns"
            :orders="orders"
            @update:orders="orders = $event"
        >
            <template #td-id="{row}">
                <router-link :to="{ name: 'AiProcessEditPage', params: { aiProcessUuid: row.uuid } }">
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-generate_fields="{row}">
                {{ generateFieldsLabel(row) }}
            </template>
            <template #td-jobs_count="{row}">
                <template v-if="row.batch">
                    <div class="mb-1">
                        <small>{{ $t('labels.ai_process_progress', {
                            done:  Object.entries(row.products_count_by_status ?? {}).filter(([s]) => s !== 'waiting' && s !== 'process').reduce((sum, [, n]) => sum + n, 0),
                            total: Object.values(row.products_count_by_status ?? {}).reduce((sum, n) => sum + n, 0),
                        }) }}</small>
                    </div>
                    <div class="progress" style="height: 6px;">
                        <div
                            class="progress-bar"
                            :style="{ width: donePercent(row) + '%' }"
                        ></div>
                    </div>
                </template>
                <span v-else>—</span>
            </template>
            <template #td-created_at="{row}">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
            <template #td-finished_at="{row}">
                <span v-if="row.batch && row.batch.finished_at">{{ DateFormatter.formatDateTime(row.batch.finished_at) }}</span>
                <span v-else>—</span>
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FetchTable from "../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../components/new/table/tableHandle";
import DateFormatter from "../../../../services/DateFormatter";
import { mapGetters } from "vuex";
import { getAiProcessFieldLabelKey, getAiProcessFields } from "../../../enums/AiProcessFieldEnum";

export default {
    name: 'AiProcessesListPage',
    components: {
        Card, FetchTable,
    },
    props: {
        integration: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            orders: [
                { column: 'id', dir: 'desc' },
            ],
            columns: [
                { key: 'id',              name: this.$t('table.titles.id'),             width: '100px', type: 'string', order: true },
                { key: 'generate_fields', name: this.$t('table.titles.generate_fields'), width: 'auto', type: 'string', order: false },
                { key: 'jobs_count',      name: this.$t('table.titles.jobs_count'),     width: '190px', type: 'string', order: false },
                { key: 'created_at',      name: this.$t('table.titles.created_at'),     width: '200px', type: 'date',   order: true },
                { key: 'finished_at',     name: this.$t('table.titles.finished_at'),    width: '200px', type: 'date',   order: false },
            ],
        };
    },
    computed: {
        ...mapGetters({
            project: 'route/project',
            profile: 'profile/profile',
        }),
    },
    methods: {
        donePercent(row) {
            const counts = row.products_count_by_status;
            if (!counts) return 0;

            const total = Object.values(counts).reduce((sum, n) => sum + n, 0);
            if (total === 0) return 0;

            const done = Object.entries(counts)
                .filter(([s]) => s !== 'waiting' && s !== 'process')
                .reduce((sum, [, n]) => sum + n, 0);

            return Math.round((done / total) * 100);
        },
        generateFieldsLabel(row) {
            const labels = getAiProcessFields(row.settings)
                .map(field => this.$t(getAiProcessFieldLabelKey(field)));

            return labels.join(', ') || '—';
        },
        onNotification(notification) {
            if (notification.type !== 'App\\Notifications\\Pim\\AiProcessTask\\AiProcessTaskStatusChangedNotification') {
                return;
            }

            const { ai_process_uuid, processed_jobs, batch_finished_at, products_count_by_status } = notification.additional_data;

            const row = this.tableHandle.rows.find(r => r.uuid === ai_process_uuid);
            if (row) {
                if (row.batch) {
                    row.batch.processed_jobs = processed_jobs;
                    if (batch_finished_at) {
                        row.batch.finished_at = batch_finished_at;
                    }
                }
                if (products_count_by_status) {
                    row.products_count_by_status = products_count_by_status;
                }
            }
        },
    },
    mounted() {
        this.tableHandle.fetchRows();

        this.emitter.on('notification:received', this.onNotification);
    },
    beforeUnmount() {
        this.emitter.off('notification:received', this.onNotification);
    },
};
</script>
